import Ordinance from './Ordinance'

export default class BaptismOrdinance extends Ordinance {
  constructor(baptism, t) {
    super({
      data: baptism,
      title: t('wcf.person-ordinances.baptism', 'Baptism'),
      t,
    })
  }
}
